import { styled } from "styled-components";
// import { useTheme } from "../../context/ThemeContext";
import { CustomSelect } from "../../utils/CustomizedLibraries/dashBoardSelectUtil";
import { filterOptions } from "../../utils/CustomizedLibraries/CustomSelectInput";
import { Squarebtn } from "../common/squareBtnProps";
import { useTheme as styledTheme } from "styled-components";

const InsightAndAnalysisCont = styled.div`
//   border: 1px solid yellow;

  h4 {
    font-weight: bold;
  }

  .alignDivEnd {
    // border: 1px solid red;
    display: flex;
    justify-content: flex-end;
    margin-bottom: 30px;
  }

  .insightsDiv {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    // border: 1px solid indigo;
  }

  .filterDiv {
    width: 40%;
    @media (max-width: 768px) {
      width: 100%;
    }
    // border: 1px solid blue;
    margin-bottom: 20px;
  }

  .actionContainer {
    width: 85%;
      @media (max-width: 992px) {
    width: 100%;
  }
    // border: 1px solid red;
    .actionDiv {
      background-color: ${({ theme }) => theme.searchInputBcg};
      border: 1px solid ${({ theme }) => theme.searchInputBdrClr};
      margin-top: 7px;
      border-radius: 20px;
      height: 60px;
      padding: 0 10px;

      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
    }
  }
`;

const TotalProjects = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  width: 200px;
  height: 105px;
  background-color: ${({ theme }) => theme.searchInputBcg};
  border: 1px solid ${({ theme }) => theme.searchInputBdrClr};
  border-radius: 12px;
`;

const InsightAndAnalysis: React.FC = () => {
  // const { theme } = useTheme();
  const styledComponentTheme = styledTheme();

  return (
    <InsightAndAnalysisCont>
      <div className="alignDivEnd">
        <TotalProjects>
          <h4>Total Projects</h4>
          <h4>7</h4>
        </TotalProjects>
      </div>

      <div className="insightsDiv">
        <h4>Activity Timeline</h4>

        <div className="filterDiv">
          <CustomSelect
            inputId="filterOption"
            placeholder="Filter by activity action"
            options={filterOptions}
          />
        </div>

        <div className="actionContainer">
          <div className="actionDiv ">
            <span>Added Project Weather Zen on 7/12/2024 </span>
            <Squarebtn
              height="40px"
              width="100px"
              radius="12px"
              $fontSize="12px"
              $bacgrndColor={styledComponentTheme.text}
              $color={styledComponentTheme.circularIconTextBg}
              $hoverBackground={styledComponentTheme.circularIconTextBg}
              $hoverColor={styledComponentTheme.text}
            >
              View issue
            </Squarebtn>
          </div>
          <div className="actionDiv ">
            <span>Added Project Weather Zen on 7/12/2024 </span>
          </div>
        </div>
      </div>
    </InsightAndAnalysisCont>
  );
};

export default InsightAndAnalysis;
